export class DepositQREnquiryModel {
    accountStatus : number;
    customerName : string;
    productName : string;
    accountNumber : string;
    amount : string;
    currency : string;
    term : string;
    interestRate : string;
    createDate : string;
    valueDate : string;
    maturityDate : string;
    paymentMethod : string;
    companyName : string;
}